/**
 * GamoraFoundationModule
 *
 * Abstract class that represents a module
 * @class
 * @public
 */
export abstract class GamoraFoundationModule {
  protected constructor() {
    return;
  }
}
